import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as DataStore from "data/DataStore";
import SeriesDetails from "./SeriesDetails";
import { getTitleUi } from "data/TitleInfoSelector";
import { performJsonpGetRequest } from "lib/HttpRequest";
import { attachFunctionToCallback, getNovSchema } from "../../../utility";
import {getSeriesDetailsOtsAvailablity} from "data/OtsRequests";
import { logFeatureUsage } from "lib/analytics/AnalyticsController";
import SimilarSeriesEventTypes from 'data/types/SimilarSeriesEventTypes';
import withOtsEnabled from 'react/containers/helper/withOtsEnabled';

const seriesInfoResultCallbackName = 'seriesInfoResultCallback';

class SeriesDetailsContainer extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading: false,
            seriesResultData: null
        };
        this.onSeriesInfoRetrieved = this.onSeriesInfoRetrieved.bind(this);
        this.fetchSeriesData = this.fetchSeriesData.bind(this);
    }

    onSeriesInfoRetrieved(data) {
        
        getSeriesDetailsOtsAvailablity(data);
        this.setState({
			isLoading: false,
			seriesResultData: data
        });
    }
    
    componentDidMount() {

		attachFunctionToCallback(this.onSeriesInfoRetrieved, seriesInfoResultCallbackName);
		this.fetchSeriesData(this.props.uniqueId);
    }

    componentWillReceiveProps(nextProps){
        if(this.props.uniqueId !== nextProps.uniqueId){
            this.fetchSeriesData(nextProps.uniqueId);
        }
    }

    fetchSeriesData(uniqueId) {
		const profileData = DataStore.getProfileData();
		this.setState({ isLoading: true });

		if (profileData) {
            logFeatureUsage(SimilarSeriesEventTypes.SIMILARSERIES_LISTCOVER_CLICKED, getTitleUi(DataStore.getJsonData()), uniqueId);
			const url = this.generateUrl(uniqueId, profileData);
			performJsonpGetRequest(url, seriesInfoResultCallbackName);
		}
    }

    generateUrl(seriesId, profileData) {
		const apiEndpoint = `${getNovSchema()}${DataStore.getBaseUrl()}/Data/GetSeriesInfo?`;
		const customerInfo = `profile=${profileData.Profile}&password=${profileData.Password}&custLinks=${DataStore.getCustLinks()}`;
		const series = `&seriesUi=${seriesId}`;
		const url = `${apiEndpoint}${customerInfo}${series}`;

		return encodeURI(url);
    }
    
    render(){
        return (<SeriesDetails {...this.props} {...this.state}/>);
    }
}

SeriesDetailsContainer.propTypes = {
    title: PropTypes.string.isRequired,
    authorName: PropTypes.string.isRequired,
    reasonText: PropTypes.string,
    uniqueId: PropTypes.string.isRequired
}

export default withOtsEnabled(SeriesDetailsContainer);
export {seriesInfoResultCallbackName};



// WEBPACK FOOTER //
// ./src/react/views/series/SeriesDetailsContainer.jsx